import { useContext, useEffect, useState } from "react";
import * as _ipt_ from "@Elementos/Input";
import * as _opt_ from "@Elementos/Opciones";
import * as _btn_ from "@Elementos/Boton";
import * as _f_ from "@Funciones/funciones";

import "./Filtros.css";

function Filtros({ titulo = undefined, filtros, funcionObtenerValores }) {
  const [inputs, einputs] = useState({
    input: _ipt_.Input4,
    date: _ipt_.InputDate
  });
  const [filtrosvalores, efiltrosvalores] = useState({});

  useEffect(() => {
    console.log(Object.keys(filtros??{}))
    filtros?.map((e, i) => {
      _f_.asignar(efiltrosvalores, {
        [e?.campofiltro]: {
          valor: "",
          operador: e?.operador,
          tipo: e?.tipoDato,
        },
      });
    });
  }, [filtros]);

  useEffect(() => {
    funcionObtenerValores?.(filtrosvalores);
  }, [filtrosvalores]);

  return (
    <>
      {titulo && <div className="titulo-componente">{titulo}</div>}
      <div className="cabecera-contenido-filtros">
        <div className="cabecera-contenido-filtro-inputs">
          {(filtros ?? []).map((filtro, i) => {
            let Componente = inputs[filtro.tipo];
            const mapaUnicodes = {
              "<": "\u003C", // <
              ">": "\u003E", // >
              ">=": "\u2265", // ≥
              "<=": "\u2264", // ≤
              "!=": "\u2260", // ≠
              "==": "\u003D", // =
              "contains": "", // =
            };

            let placeholder =
              `${filtro.campofiltro} ` + mapaUnicodes[filtro.operador] || "";

            return (
              <Componente
                key={i}
                estilos={{ flexGrow: 1 }}
                texto={placeholder}
                tipo="text"
                name={i}
                value={filtrosvalores[filtro?.campofiltro]?.valor ?? ""}
                onChange={(evento) => {
                  _f_.asignar(efiltrosvalores, {
                    [filtro.campofiltro]: _f_.asignar(
                      filtrosvalores[filtro.campofiltro],
                      { valor: evento.target.value },
                    ),
                  });
                }}
              />
            );
          })}
          {/* 
          <_opt_.Opcion2
            clave="clave"
            valor="valor"
            opciones={opciones || []}
            texto="seleccione"
            name={"wefwfwefwef"}
            estilos={{ flexGrow: 1, width: "100%" }}
            onBlur={(evento) => {
              console.log(evento.target.getAttribute("value"));
            }}
          /> */}
        </div>
        {(Object.keys(filtros??{}).length > 0) && <div className="cabecera-contenido-filtro-boton">
          <_btn_.Boton
            texto="Limpiar Filtros"
            tipo="btn-2"
            estilos={{ color: "#941b12", anchoB2: "10rem" }}
            onClick={() => {
              // Object.keys(filtrosvalores).map((clave) => {
              //   _f_.asignar(efiltrosvalores, { [clave]: "" });
              // });
              filtros?.map((e, i) => {
                _f_.asignar(efiltrosvalores, {
                  [e?.campofiltro]: {
                    valor: "",
                    operador: e?.operador,
                    tipo: e?.tipoDato,
                  },
                });
              });
            }}
          />
        </div>}
      </div>
    </>
  );
}
export default Filtros;
